import { render } from "./EditSupplierModal.vue?vue&type=template&id=67d55e50"
import script from "./EditSupplierModal.vue?vue&type=script&lang=js"
export * from "./EditSupplierModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__